import React, { useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Select, Popover, Button, Space } from "antd";
import styles from "./index.module.scss";

const { Option } = Select;

const EditGroupPopover = ({ group, allAccounts, selectedAccounts, onRemoveGroup, onUpdateSelectedAccounts, onConfirmEditGroup }) => {
  const [showPopover, setShowPopover] = useState(false);

  const popOverTitle = (
    <div className={styles.editTitle}>
      <div>Select Accounts</div>
      <Button type="link" onClick={() => onRemoveGroup(group)}>
        Remove Group
      </Button>
    </div>
  );

  const editGroupPopOverContent = (
    <React.Fragment key={group}>
      <Select
        mode="multiple"
        allowClear
        style={{ width: 320 }}
        placeholder="Please select"
        value={selectedAccounts}
        onChange={(newSelectedAccounts) => onUpdateSelectedAccounts(newSelectedAccounts)}
      >
        {allAccounts // 所有status在一个array
          .map((account) => (
            <Option key={account}>{account}</Option>
          ))}
      </Select>
      <div className={styles.editGroupbtn}>
        <Space size={25}>
          <Button size="small" onClick={() => setShowPopover(false)}>
            Cancel
          </Button>
          <Button
            size="small"
            type="primary"
            onClick={() => {
              onConfirmEditGroup(group);
              setShowPopover(false);
            }}
          >
            {selectedAccounts && selectedAccounts.length > 0 ? "Confirm" : "Confirm Remove Group"}
          </Button>
        </Space>
      </div>
    </React.Fragment>
  );

  return (
    <Popover placement="bottom" title={popOverTitle} open={showPopover} content={editGroupPopOverContent} onOpenChange={setShowPopover}>
      <div onClick={() => setShowPopover(!showPopover)}>
        <EditOutlined /> {"Edit group"}
      </div>
    </Popover>
  );
};

export default EditGroupPopover;
